/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { createPermission } from '@backstage/plugin-permission-common';

import { RESOURCE_TYPE_CATALOG_ENTITY } from '@backstage/plugin-catalog-common/alpha';

export const catalogEntityEditPermission = createPermission({
  name: 'catalog.entity.edit',
  attributes: {
    action: 'update',
  },
  resourceType: RESOURCE_TYPE_CATALOG_ENTITY,
});

export const entityFeedbackRateEntityPermission = createPermission({
  name: 'entityFeedback.entity.rate',
  attributes: {
    action: 'create',
  },
});

export const dashboardReadPermission = createPermission({
  name: 'dashboard.read',
  attributes: {
    action: 'read',
  },
});

export const customPermissions = [catalogEntityEditPermission];
